import { render, staticRenderFns } from "./EstablishmentViewSalesOrders.vue?vue&type=template&id=1a21972a"
import script from "./EstablishmentViewSalesOrders.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewSalesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports